import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router'; //, Params


import { UserProvider } from '../providers/user/user';
import { BasicProvider } from '../providers/basic/basic';

@Component({
  selector: 'app-account-verity',
  templateUrl: './account-verify.component.html',
  styleUrls: ['./account-verify.component.css']
})
export class AccountVerifyComponent implements OnInit {

  constructor(
    public bp:BasicProvider, 
    public up:UserProvider,
    private activatedRoute: ActivatedRoute,
    public router: Router,
  ) {
      console.log('dfd');
   }

  ngOnInit() {
    let token = this.activatedRoute.snapshot.params['token'];
    this.verifyAccount(token);
  }

  verifyAccount(token){
    
    this.bp.hitApi('web/verify-account/'+token, 'GET', {}, true, true)
    .subscribe(
      success => {
        if (success.type == true) {
          this.bp.show_toast('Success',success.message);
          this.router.navigate(['home']);
        } else {
          this.bp.show_toast('Error',success.message);
          this.router.navigate(['home']);
        }
      }, 
      error => {

      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/account-verify/account-verify.component.ts